import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import CreateUserService from '../utils/UserService';
import { useLanguage } from '../contexts/LanguageContext';
import { getColumns } from './GridData'; // ✅ Import columns function

export default function CustomizedDataGrid() {
  const [rows, setRows] = useState<any[]>([]);
  const UserService = CreateUserService();

  // ✅ Retrieve translations from language context
  const { translations } = useLanguage();
  // ✅ Generate columns dynamically
  const columns = getColumns(translations);

  // Load row data from your backend
  useEffect(() => {
    UserService.getStoresActionsStats().then((response) => {
      if (!response) {
        console.error("No response from backend");
        return;
      }
      if (response.status === 200) {
        setRows(response.data);
      }
    })
  }, []);

  React.useEffect(() => {
  }, []);

  return (
      <DataGrid
        checkboxSelection
        rows={rows}
        columns={columns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
        }}
        pageSizeOptions={[10, 20, 50]}
        disableColumnResize
        density="compact"
      slotProps={{
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: 'outlined',
                size: 'small',
              },
            },
          },
        },
      }}
    />
  );
}
